<ng-template #dialogTitle>
    <div class="required-action-info-dialog__title">
        <i class="required-action-info-dialog__title-icon" [ngClass]="titleIconClass()" aria-hidden="true"></i>
        <span>{{ data()?.title }}</span>
    </div>
</ng-template>

<app-form-popup
    [width]="500"
    [height]="420"
    [visible]="visible()"
    [titleText]="data()?.title ?? ''"
    [titleTemplate]="dialogTitle"
    [wrapperAttr]="{ class: 'required-action-info-dialog' }"
    [footerButtons]="footerButtons()"
    (clicked)="onFooterClicked($event)"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="required-action-info-dialog__content">
        @if (data(); as view) {
            <div class="required-action-info-dialog__detail-row">
                <span class="required-action-info-dialog__detail-label">{{ 'label_status' | transloco }}</span>
                <app-status-badge [status]="view.status" [label]="view.statusLabel" [tooltipTranslationKey]="view.statusTooltipKey ?? null" />
            </div>

            <div class="required-action-info-dialog__detail-row">
                <span class="required-action-info-dialog__detail-label">{{ 'label_type' | transloco }}</span>
                <span class="required-action-info-dialog__detail-value">{{ view.reason }}</span>
            </div>

            <div class="required-action-info-dialog__detail-row">
                <span class="required-action-info-dialog__detail-label">{{ 'label_creationDate' | transloco }}</span>
                <span class="required-action-info-dialog__detail-value">{{ view.createdAt }}</span>
            </div>

            <div class="required-action-info-dialog__detail-row">
                <span class="required-action-info-dialog__detail-label">{{ 'label_createdBy' | transloco }}</span>
                <span class="required-action-info-dialog__detail-value">{{ view.createdBy }}</span>
            </div>

            <div class="required-action-info-dialog__detail-row required-action-info-dialog__description-section">
                <span class="required-action-info-dialog__detail-label">{{ 'label_description' | transloco }}</span>
                <div class="required-action-info-dialog__detail-value">
                    {{ view.description }}
                </div>
            </div>
        }
    </div>
</app-form-popup>
